import { Fragment } from '@tiptap/pm/model';
import { TextSelection, type EditorState } from '@tiptap/pm/state';

/** Move complete audio/visual pairs without crossing section boundaries. */
export function rowAction(state: EditorState, action: 'duplicate' | 'up' | 'down') {
  const { $from } = state.selection;
  let depth = $from.depth;
  while (depth > 0 && $from.node(depth).type.name !== 'scriptRow') depth--;
  if (!depth) return null;
  const row = $from.node(depth);
  const start = $from.before(depth);
  const end = start + row.nodeSize;
  const offset = $from.pos - start;
  const tr = state.tr;
  let destination = start;
  if (action === 'duplicate') {
    tr.insert(end, row);
    destination = end;
  } else if (action === 'up') {
    const previous = state.doc.resolve(start).nodeBefore;
    if (previous?.type.name !== 'scriptRow') return null;
    destination = start - previous.nodeSize;
    tr.replaceWith(destination, end, Fragment.fromArray([row, previous]));
  } else {
    const next = state.doc.resolve(end).nodeAfter;
    if (next?.type.name !== 'scriptRow') return null;
    tr.replaceWith(start, end + next.nodeSize, Fragment.fromArray([next, row]));
    destination = start + next.nodeSize;
  }
  tr.setSelection(TextSelection.near(tr.doc.resolve(destination + offset)));
  return tr.scrollIntoView();
}
